import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export const url = {
  request: `/request`
}

export async function requestSearch(filters = {}) {
  try {
    
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.request}/list?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in requestSearch:', error)
    throw error
  }
}

export async function requestAdd(body) {
  const newBody = {
    ...body,
    from: 2
  }
  const response = await apiCMSWithToken.post(`${url.request}/add`, newBody)
  return response
}

export async function requestUpdate(body) {
  const response = await apiCMSWithToken.put(`${url.request}/edit`, body)
  return response
}

export async function requestDetail(id) {
  try {
    const response = await apiCMSWithToken.get(`${url.request}/${id}`)

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function showRequestPhone(id) {
  const response = await apiCMSWithToken.get(`${url.request}/${id}/show-phone`)
  return response
}

export async function requestDelete(body) {
  const response = await apiCMSWithToken.delete(`${url.request}/delete`, {
    data: body
  })
  return response
}

export async function requestManagerAdd(body) {
  try {
    const response = await apiCMSWithToken.post(`${url.request}/manager`, body)
    return response
  } catch (error) {
    console.error('Error in requestSearch:', error)
    throw error
  }
}

export async function listManageRequest(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${url.request}/request-history?type=5&request_id=${id}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function userRequestDelete(body) {
  const response = await apiCMSWithToken.delete(
    `${url.request}/request-history`,
    {
      data: body
    }
  )
  return response
}

export async function requestHistory(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.request}/request-history?${params}&type=2&type=5&type=6&type=7&type=8`
    )
    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function bookHistory(id) {
  try {
    const response = await apiCMSWithToken.get(`${url.request}/list-book/${id}`)
    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function listNote(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.request}/request-history?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function noteAdd(body) {
  const response = await apiCMSWithToken.post(`${url.request}/note`, body)
  return response
}

export async function noteUpdate(body) {
  const response = await apiCMSWithToken.put(
    `${url.request}/request-history`,
    body
  )
  return response
}

export async function noteDelete(body) {
  const response = await apiCMSWithToken.delete(
    `${url.request}/request-history`,
    {
      data: body
    }
  )
  return response
}

// export async function listUserPost(id) {
//   try {
//     const response = await apiCMSWithToken.get(
//       `${F18_SERVICES.postAction}/manager_post/${id}`
//     )
//     return response
//   } catch (error) {
//     console.error('Error in postSearch:', error)
//     throw error
//   }
// }

// export async function userPostAdd(body) {
//   const response = await apiCMSWithToken.post(
//     `${F18_SERVICES.postAction}/manager_post`,
//     body
//   )
//   return response
// }

// export async function userPostDelete(body) {
//   const response = await apiCMSWithToken.delete(
//     `${F18_SERVICES.postAction}/manager_post`,
//     {
//       data: body
//     }
//   )
//   return response
// }

export default {
  requestSearch,
  requestAdd,
  requestUpdate,
  requestDelete,
  requestDetail,
  requestManagerAdd,
  listManageRequest,
  userRequestDelete,
  requestHistory,
  bookHistory,
  listNote,
  noteAdd,
  noteUpdate,
  noteDelete
}
